<template>
    <div>
        <v-list-tile @click="abrirModalCancelarNegociacao">
            <v-list-tile-title>
                Cancelar Última Negociação
            </v-list-tile-title>
        </v-list-tile>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="mostrarModalCancelarNegociacao">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{itemOuLoteDescricao}}</strong> | Cancelar Última Negociação</span>
                    <v-btn flat depressed @click="fecharModalCancelarNegociacao">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0 az-form-content">
                    <div class="az-text mb-3">
                        <label>Fornecedor</label>
                        <p>{{razaoSocial}}</p>
                    </div>

                    <v-textarea v-model="motivoCancelamentoNegociacao"
                                :error-messages="errors.collect('Motivo do Cancelamento')"
                                v-validate="'required'"
                                label="Motivo do Cancelamento"
                                :name="'Motivo do Cancelamento'"
                                placeholder="Digite aqui seu motivo"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"
                                class="required-field"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" outline flat @click="fecharModalCancelarNegociacao">
                        Voltar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoCancelarNegociacao" depressed color="primary" @click="cancelarNegociacao">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'AcoesCancelarNegociacao',
    props: ['itemOuLoteDescricao', 'razaoSocial'],
    data() {
        return {
            mostrarModalCancelarNegociacao: false,
            motivoCancelamentoNegociacao: null,
            Modal
        }
    },
    methods: {
        async cancelarNegociacao() {
            await this.validarPreenchimento()
            this.$emit('cancelarNegociacao', {motivo: this.motivoCancelamentoNegociacao})
            this.fecharModalCancelarNegociacao()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validateAll()
            if (!estaValidado) {
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        abrirModalCancelarNegociacao() {
            setTimeout(() => {
                this.mostrarModalCancelarNegociacao = !this.mostrarModalCancelarNegociacao
            }, 500)
        },
        fecharModalCancelarNegociacao() {
            this.mostrarModalCancelarNegociacao=false
            this.motivoCancelamentoNegociacao=null
            this.$validator.reset()
        },
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>